import { render, staticRenderFns } from "./LawMatterEvidenceDetectionCounterPartyList.vue?vue&type=template&id=40a12fa0&"
import script from "./LawMatterEvidenceDetectionCounterPartyList.vue?vue&type=script&lang=js&"
export * from "./LawMatterEvidenceDetectionCounterPartyList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterEvidenceDetectionCounterPartyList.vue?vue&type=style&index=0&id=40a12fa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports